import { takeLatest, put } from 'redux-saga/effects';
import { requestLinksTrackingStatistics } from './api';
import { statisticsLinksTrackingSuccess } from './actions';

import { GET_LINKS_TRACKING_CALENDAR} from './constants';

/**
 *
 * @param action
 * @returns {IterableIterator<PutEffect<{type: string, statistics: *}>>}
 */
function* getLinksTrackingStatistics(action) {
    const statistic = yield requestLinksTrackingStatistics(action.calendarID);

    if (statistic){
        yield put( statisticsLinksTrackingSuccess (statistic) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchLinksTrackingCalendar(){
    yield  takeLatest(GET_LINKS_TRACKING_CALENDAR, getLinksTrackingStatistics);
}

export default watchLinksTrackingCalendar;